// ============================
// FORM VALIDATION & SUBMISSION
// ============================

function validateEmail(email) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
}

function validatePhone(phone) {
  return /^[\d\s\+\-\(\)]{7,20}$/.test(phone.trim());
}

function showFieldError(field, msg) {
  field.style.borderColor = '#E4002B';
  let err = field.parentElement.querySelector('.field-error');
  if (!err) {
    err = document.createElement('span');
    err.className = 'field-error';
    err.style.cssText = 'color: #E4002B; font-size: 12px; display: block; margin-top: 4px; font-family: var(--font-acumin); font-variation-settings: var(--font-acumin-variation);';
    field.parentElement.appendChild(err);
  }
  err.textContent = msg;
}

function clearFieldError(field) {
  field.style.borderColor = '';
  const err = field.parentElement.querySelector('.field-error');
  if (err) err.remove();
}

// Newsletter form
(function initNewsletterForms() {
  const submittedEmailsKey = 'gummiPopzNewsletterSubmittedEmails';
  const pendingEmailKey = 'gummiPopzNewsletterPendingEmail';

  function normalizeEmail(value) {
    return value.trim().toLowerCase();
  }

  function readSubmittedEmails() {
    try {
      return JSON.parse(window.localStorage.getItem(submittedEmailsKey) || '[]');
    } catch (error) {
      return [];
    }
  }

  function rememberSubmittedEmail(email) {
    if (!email) return;

    const emails = readSubmittedEmails();
    if (emails.includes(email)) return;

    emails.push(email);
    try {
      window.localStorage.setItem(submittedEmailsKey, JSON.stringify(emails.slice(-20)));
    } catch (error) {}
  }

  function showAlreadySubscribedMessage(form) {
    const row = form.querySelector('.newsletter-form__row');
    const message = form.querySelector('[data-already-subscribed]');

    if (!message) return false;
    if (row) row.hidden = true;

    message.hidden = false;
    message.focus({ preventScroll: true });
    return true;
  }

  function rememberSuccessfulSubmit(form) {
    if (!form.querySelector('.newsletter-message--success')) return;

    try {
      const pendingEmail = window.sessionStorage.getItem(pendingEmailKey);
      rememberSubmittedEmail(pendingEmail || '');
      window.sessionStorage.removeItem(pendingEmailKey);
    } catch (error) {}
  }

  function showReturnedAlreadySubscribedState(form) {
    const emailInput = form.querySelector('input[name="contact[email]"]');
    const hasReturnedCustomerForm = window.location.href.includes('form_type=customer');

    if (!hasReturnedCustomerForm || !emailInput || !emailInput.value.trim()) return;
    showAlreadySubscribedMessage(form);
  }

  document.querySelectorAll('.newsletter-form').forEach(form => {
    rememberSuccessfulSubmit(form);

    setTimeout(() => showReturnedAlreadySubscribedState(form), 0);
    setTimeout(() => showReturnedAlreadySubscribedState(form), 150);

    form.addEventListener('submit', e => {
      const emailInput = form.querySelector('input[name="contact[email]"]');
      if (!emailInput) return;

      const email = normalizeEmail(emailInput.value);
      clearFieldError(emailInput);

      if (!validateEmail(email)) {
        e.preventDefault();
        showFieldError(emailInput, 'Please enter a valid email address.');
        return;
      }

      if (readSubmittedEmails().includes(email) && showAlreadySubscribedMessage(form)) {
        e.preventDefault();
        return;
      }

      try {
        window.sessionStorage.setItem(pendingEmailKey, email);
      } catch (error) {}
    });
  });
})();
// Contact form
(function initContactForm() {
  const form = document.querySelector('#contact-form');
  if (!form) return;

  form.addEventListener('submit', e => {
    e.preventDefault();
    let valid = true;

    const fields = {
      name: { el: form.querySelector('[name="name"]'), msg: 'Please enter your name.' },
      email: { el: form.querySelector('[name="email"]'), msg: 'Please enter a valid email.' },
      message: { el: form.querySelector('[name="message"]'), msg: 'Please enter your message.' }
    };

    Object.values(fields).forEach(f => {
      if (f.el) clearFieldError(f.el);
    });

    if (!fields.name.el?.value.trim()) { showFieldError(fields.name.el, fields.name.msg); valid = false; }
    if (!validateEmail(fields.email.el?.value.trim())) { showFieldError(fields.email.el, fields.email.msg); valid = false; }
    if (!fields.message.el?.value.trim()) { showFieldError(fields.message.el, fields.message.msg); valid = false; }

    if (!valid) return;

    const success = form.querySelector('.form-success');
    if (success) {
      success.textContent = 'Thanks! We\'ll be in touch within 1–2 working days.';
      success.classList.add('show');
    }

    form.reset();
    setTimeout(() => { if (success) success.classList.remove('show'); }, 6000);
  });
})();

// Wholesale form
(function initWholesaleForm() {
  const form = document.querySelector('#wholesale-form');
  if (!form) return;

  form.addEventListener('submit', e => {
    e.preventDefault();
    let valid = true;

    const requiredFields = form.querySelectorAll('[required]');
    requiredFields.forEach(field => {
      clearFieldError(field);
      if (!field.value.trim()) {
        showFieldError(field, 'This field is required.');
        valid = false;
      } else if (field.type === 'email' && !validateEmail(field.value.trim())) {
        showFieldError(field, 'Please enter a valid email address.');
        valid = false;
      }
    });

    if (!valid) return;

    const success = form.querySelector('.form-success');
    if (success) {
      success.textContent = 'Brilliant! Your wholesale enquiry has been received. Our team will be in touch within 1–2 working days with trade pricing.';
      success.classList.add('show');
    }

    form.reset();
    setTimeout(() => { if (success) success.classList.remove('show'); }, 8000);
  });
})();

// Clear errors on input
document.querySelectorAll('input, textarea, select').forEach(field => {
  field.addEventListener('input', () => clearFieldError(field));
});
